import Plotly from "plotly.js";
import { useContext, useEffect } from "react";

import { TimelineContext } from "../timeline-chart";

interface VerticalLineProps {
  time: Date; // Time of the vertical line
  color?: string; // Optional color for the vertical line
  width?: number; // Optional width for the vertical line
  dash?: Plotly.Dash; // Optional dash type for the vertical line
}

export function VerticalLine({
  time,
  color = "#00f",
  width = 3,
  dash = "solid",
}: VerticalLineProps) {
  const { dispatch } = useContext(TimelineContext);

  // Compute a unique ID for the vertical line based on its properties
  const id = `vertical-line-${time.getTime()}-${color}-${width}-${dash}`;

  dispatch({
    type: "ADD_VERTICAL_LINE",
    verticalLine: { id, time, color, width, dash },
  });

  // Cleanup function to remove the vertical line when the component is unmounted
  useEffect(() => {
    return () => {
      dispatch({ type: "REMOVE_VERTICAL_LINE", id });
    };
  }, [id, dispatch]);

  return null;
}

function VerticalLineNow(props: Partial<VerticalLineProps>) {
  const now = new Date();

  return <VerticalLine time={now} color="#3CDBAF" width={3} dash="solid" {...props} />;
}

VerticalLine.Now = VerticalLineNow;
